import { LoadingScreen } from '@tyro/core/lazy-loader';
import { RouterProvider } from 'react-router';
import { type AppRouterProps, useAppRouter } from '../hooks/use-app-router';

export function Router(props: AppRouterProps) {
  const appRouter = useAppRouter(props);

  if (!appRouter) {
    return <LoadingScreen />;
  }

  return <RouterProvider router={appRouter} />;
}
